import React from 'react';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container py-1">
        <div className="row footer-grid">
          {/* Contact Us Column */}
          <div className="col-md-3 footer-col footer-col-contact">
            <h3 className="footer-title">Contact Us</h3>
            <div className="footer-content">
              <p className="footer-text">
                <i className="fas fa-mobile-alt me-2"></i>
                <a href="tel:+919662267474" className="footer-phone-link">+91 96622 67474</a>
              </p>
              <h6 className="footer-address-heading">Office Address</h6>
              <p className="footer-text">
                <i className="fas fa-map-marker-alt me-2"></i>
                <a 
                  href="https://maps.google.com/?q=52%2FA%2C+Titanium+Building%2C+Prahladnagar+Garden%2C+Ahmedabad-380015%2C+Gujarat" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-phone-link"
                >
                  52/A, Titanium Building,<br />
                  Prahladnagar Garden,<br />
                  Ahmedabad- 380015, Gujarat
                </a>
              </p>
            </div>
          </div>

          {/* Useful Links Column */}
          <div className="col-md-3 footer-col footer-col-links">
            <h3 className="footer-title">Useful Links</h3>
            <div className="footer-content">
              <ul className="footer-links">
                <li><a href="/" className="footer-link">Personal Loans</a></li>
                <li><a href="/emi-calculator" className="footer-link">EMI Calculator</a></li>
                <li><a href="/lending-partner" className="footer-link">Lending Partners</a></li>
                {/* <li><a href="/credit-score" className="footer-link">Credit Score</a></li> */}
              </ul>
            </div>
          </div>

          {/* Legal Column */}
          <div className="col-md-3 footer-col footer-col-legal">
            <h3 className="footer-title">Legal</h3>
            <div className="footer-content">
              <ul className="footer-links">
                <li><a href="/privacy-policy" className="footer-link">Privacy Policy</a></li>
                {/* <li><a href="/terms-conditions" className="footer-link">Terms & Conditions</a></li> */}
              </ul>
            </div>
          </div>

          {/* Follow Us Column */}
          <div className="col-md-3 footer-col footer-col-follow">
            <h3 className="footer-title">Follow Us</h3>
            <div className="footer-content">
              <div className="social-icons">
                <div className="social-icons-row">
                  <div className="social-icon">
                    <a href="https://www.facebook.com/profile.php?id=61556485389669" target="_blank" rel="noopener noreferrer">
                      <img src="/images/facebook-icon.png" alt="Facebook" />
                    </a>
                  </div>
                  <div className="social-icon">
                    <a href="https://www.instagram.com/snapfunds_smile/" target="_blank" rel="noopener noreferrer">
                      <img src="/images/instagram-icon.png" alt="Instagram" />
                    </a>
                  </div>
                  <div className="social-icon">
                    <a href="https://www.linkedin.com/company/101658237/admin/dashboard/" target="_blank" rel="noopener noreferrer">
                      <img src="/images/linkedin-icon.png" alt="LinkedIn" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;